module Meevo.Plugins.Register {

    export class RegisterClientAccountService {
        constructor(
            public $q: ng.IQService,
            public $translate: angular.translate.ITranslateService,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            public roundingService: Meevo.Components.Common.IRoundingService
        ) {
        }

        getClientAccountBalancesForCheckout(registerContext: Meevo.Plugins.Register.RegisterContext, checkoutServices: any[]) {
            let uniqueClientIds = _(checkoutServices.filter(checkoutService => !!checkoutService.clientId)
                .map(checkoutService => checkoutService.clientId)).unique();

            if (registerContext.sale.clientAccountBalances) {
                const existingClientAccountBalances = registerContext.sale.clientAccountBalances.map(balanceInfo => balanceInfo.clientId);
                uniqueClientIds = uniqueClientIds.filter(clientId => existingClientAccountBalances.indexOf(clientId) === -1);
            }

            if (uniqueClientIds.length < 1) {
                return this.$q.resolve();
            }

            var promises = uniqueClientIds
                .map(clientId => this.dataService.getItem("client", new Guid(clientId), "accountbalance")
                .then((response: any) => { 
                    response.clientId = clientId;
                    return response;
                }));

            return this.$q.all(promises).then(response => {
                if (!registerContext.sale.clientAccountBalances) {
                    registerContext.sale.clientAccountBalances = response;
                    return;
                }
                registerContext.sale.clientAccountBalances.push(...response);
            });
        }        

        private createCreditSaleLine(amount: number, originalBalance: number, client: Model.ClientListItem) {
            let saleLine = this.createClientAccountSaleLine(Model.SalesTypeEnum.ClientAccountCredit, originalBalance, amount, client);
            return saleLine;
        }

        private createPaymentSaleLine(amount: number, originalBalance: number, client: Model.ClientListItem) {
            let saleLine = this.createClientAccountSaleLine(Model.SalesTypeEnum.ClientAccountPayment, originalBalance, amount, client);
            return saleLine;
        }

        generateClientAccountSaleLines(sale: Model.Sale, client: Model.ClientListItem, amount: number, currentBalance: number, employee: Model.EmployeeListItem) {
            let paymentSaleLine;
            let creditSaleLine;

            let remainingAmount = amount;

            if (currentBalance < 0) {
                const paymentAmount = Math.min(amount, Math.abs(currentBalance));
                currentBalance = this.roundingService.addNormalizedNumbers(currentBalance, paymentAmount);
                remainingAmount = this.roundingService.subtractNormalizedNumbers(remainingAmount, paymentAmount);
                paymentSaleLine = this.createPaymentSaleLine(paymentAmount, currentBalance, client);
            }

            if (remainingAmount > 0) {
                const creditAmount = remainingAmount;
                creditSaleLine = this.createCreditSaleLine(creditAmount, currentBalance, client);
            }

            if (paymentSaleLine) {
                paymentSaleLine.employeeId = employee.id;
                paymentSaleLine.employee = employee;
                sale.saleLines.push(paymentSaleLine);
            }
                
            if (creditSaleLine) {
                creditSaleLine.employeeId = employee.id;
                creditSaleLine.employee = employee;
                sale.saleLines.push(creditSaleLine);
            }
        }

        private getDisplayName(saleType: Model.SalesTypeEnum, client: Meevo.Model.ClientListItem): string {
            switch (saleType) {
                case Model.SalesTypeEnum.ClientAccountCredit:
                    return `${this.$translate.instant("LABEL_CLIENT_ACCOUNT_CREDIT_FOR")}: ${client.displayName}`;
                case Model.SalesTypeEnum.ClientAccountPayment:
                    return `${this.$translate.instant("LABEL_CLIENT_ACCOUNT_PAYMENT_FOR")}: ${client.displayName}`;
                case Model.SalesTypeEnum.DepositCredit:
                    return this.$translate.instant("LABEL_DEPOSIT_CREDIT_FOR", { clientDisplayName: client.displayName });
            }

            return null;
        }

        private createClientAccountSaleLine(saleType: Model.SalesTypeEnum, originalBalance: number, amount: number, client: Model.ClientListItem) : Model.SaleLine {
            if (saleType != Meevo.Model.SalesTypeEnum.ClientAccountCredit && 
                saleType != Meevo.Model.SalesTypeEnum.ClientAccountPayment) {
                return null;
            }

            const saleLineItem = new Meevo.Plugins.Register.ClientAccountSaleLineItem({
                id: client.id,
                client: client,
                clientId: client.id,
                originalBalance: originalBalance, // TODO: can this be removed? appears unused (possibly incorrect)
                displayName: this.getDisplayName(saleType, client),
            });

            const saleLine: Model.SaleLine = {
                item: saleLineItem,
                quantity: 1,
                baseItemPrice: amount,
                finalItemPrice: amount,
                basePrice: amount,
                finalPrice: amount,
                client: client,
                clientId: client.id,
                clientType: Meevo.Model.ClientTypeEnum.Client,
                saleType: saleType,
                isNew: true,
                isRefund: false,
                showPoleMessage: Model.SaleLineStatusEnum.Added
            };

            return saleLine;
        }

        static factory(): Function {
            let svc = (
                $q,
                $translate,
                dataService,
                roundingService
            ) => new RegisterClientAccountService(
                $q,
                $translate,
                dataService,
                roundingService
            );

            svc.$inject = [
                "$q",
                "$translate",
                "meevo.components.common.DataService",
                "meevo.components.common.RoundingService"
            ];

            return svc;
        }
    }

    angular.module("meevo.plugins.register")
        .factory("meevo.plugins.register.RegisterClientAccountService", RegisterClientAccountService.factory());
}
